// ZIP archives in the browser: shared/zip.js with the browser's own deflate (DecompressionStream / CompressionStream,
// 'deflate-raw', in every browser since 2023). readZip(bytes) -> Map of path -> Uint8Array; writeZip(files) -> Uint8Array.
import { buildZip, parseZip } from '/zip.js';

const stream = (kind, bytes) => new Response(new Blob([bytes]).stream().pipeThrough(kind)).arrayBuffer().then((b) => new Uint8Array(b));
const inflate = (bytes) => stream(new DecompressionStream('deflate-raw'), bytes);
const deflate = typeof CompressionStream === 'function' ? (bytes) => stream(new CompressionStream('deflate-raw'), bytes) : null;

export const readZip = (bytes) => parseZip(bytes, inflate);
export const writeZip = (files) => buildZip(files, deflate);
